import React, {Component} from 'react';
import LoginAccountInput from "../LoginAccountInput";
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import PubSub from "pubsub-js";
import ImgCodeInput from "../ImgCodeInput";
import EntryInputCode from "../EntryInputCode";
import LoginCodeSetName from "../LoginCodeSetName";
import './index.css'
import LoginCodeSetPassword from "../LoginCodeSetPassword";

class LoginWXReg extends Component {
    state={
        countryCode:"",
        mobileValue:"",
        pageSwitch:{
            EntryInputCodeShow:false,
            BindWXShow:false,
            SetNameShow:false,
            LoginCodeSetPasswordShow:false,
            WXPasswordShow:true
        },
        check:true,
    }
    accountValue = (ref) =>{
        this.account = ref
    }

    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }
    codeLogin = () =>{
        const code = this.imgCode.getValue();
        const accountValue = this.account.getValue();
        const {check} = this.state;
        if(!check){
            tipAlert({
                type: "error",
                msg : React.language('m.tiaokuan.entry.error')
            })
        }
        const data = accountValue.accountType === "mobile" ?{
            "mode":"mobile_code",  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
            "data":{
                "mobile":accountValue.value,
                "country_code":accountValue.countryCode,  //地区编码
                "code":code.value //图形验证码
            }
        }:{
            "mode":"email_code",  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
            "data":{
                "email":accountValue.value,
                "code":code.value //图形验证码
            }
        }
        React.axios('/user/signin',data).then(res =>{
            if(res.data.code===200){
                tipAlert({
                    type: "success",
                    msg : res.data.msg
                })
                this.changeContCodePage('EntryInputCodeShow')
                this.setState({
                    countryCode:accountValue.countryCode,
                    mobileValue:accountValue.value,
                })
                PubSub.publish('codeCont',{value:accountValue});
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res=>{
            const res1 =  res.response ? res.response.data : res.data;
            this.imgCode.changeCode()
            if(res1.toString().indexOf('"Message":"OK"') === -1)
            {
                if(res1.toString().indexOf('code'))
                {
                    tipAlert({
                        type: "error",
                        msg : res1.msg
                    })
                }
                else
                {
                    tipAlert({
                        type: "error",
                        msg : React.language("System.error")
                    })
                }
            }else{
                tipAlert({
                    type: "success",
                    msg : res1.msg
                })
                this.changeContCodePage('EntryInputCodeShow')
                this.setState({
                    countryCode:accountValue.countryCode,
                    mobileValue:accountValue.value,
                })
                PubSub.publish('codeCont',{value:accountValue});
            }
        })
    }
    LoginCode = (values,state, cd) =>{
        const {value, countryCode, accountType} = state
        this.timer1 = setTimeout(()=>{
            const data= accountType === "mobile" ?{
                "mode":"mobile",
                "data":{
                    "mobile":value,
                    "country_code":countryCode,
                    "code":values
                }
            } : {
                "mode":"email",
                "data":{
                    "email":value,
                    "code":values
                }
            }
            React.axios('/user/signin',data).then(res =>{
                if(res.data.code===200){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    window.location.href = res.data.redirectTo
                }else if(res.data.code===203){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    this.changeContCodePage('BindWXShow')
                }else if(res.data.code===202){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    this.changeContCodePage('SetNameShow')
                }else if(res.data.code===201){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    this.changeContCodePage('LoginCodeSetPasswordShow')
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
            }).catch(res=>{
                const res1 =  res.response ? res.response.data : res.data;
                this.imgCode.changeCode()
                if(res1.toString().indexOf('"Message":"OK"') === -1)
                {
                    if(res.toString().indexOf('code'))
                    {
                        tipAlert({
                            type: "error",
                            msg : res1.msg
                        })
                        cd && cd(!0, res1.msg);
                    }
                    else
                    {
                        tipAlert({
                            type: "error",
                            msg : React.language("System.error")
                        })
                        cd && cd(!0, React.language("System.error"));
                    }
                }else{
                    if(res1.code===200){
                        tipAlert({
                            type: "success",
                            msg : res1.msg
                        })
                        window.location.href = res1.redirectTo
                    }else if(res1.code===203){
                        tipAlert({
                            type: "success",
                            msg : res1.msg
                        })
                        this.changeContCodePage('BindWXShow')
                    }
                }
            })
        },300)
    }

    componentDidMount() {
        const el = document.getElementsByClassName("LoginWXReg")[0]
        el.addEventListener("keyup", (event) =>{
            if(event.keyCode === 13){
                this.codeLogin()
            }
        })
    }

    WXBindClick = () =>{
        const data={
            "mode":"wx_login_bind",
            "data":{

            }
        }
        React.axios('/user/signin',data).then(res =>{
            if(res.data.code===200){
                tipAlert({
                    type: "success",
                    msg : res.data.msg
                })
                window.location.href = res.data.redirectTo
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res=>{
            const res1 =  res.response ? res.response.data : res.data;
            tipAlert({
                type: "error",
                msg : res1.msg
            })
        })
    }

    changeContCodePage = (value) =>{
        const {pageSwitch} = this.state;
        for(let key  in pageSwitch){
            pageSwitch[key] = false;
            if(key === value) pageSwitch[key] = true;
        }
        this.setState({pageSwitch:pageSwitch})
    }

    radioClick = () => {
        const {check} = this.state
        this.setState({check:!check})
    }

    render() {
        const {check, mobileValue} = this.state
        const {EntryInputCodeShow,WXPasswordShow, BindWXShow, SetNameShow, LoginCodeSetPasswordShow} = this.state.pageSwitch
        return (
            <div className="LoginWXReg">
                {(window.data_config.mobileCodeLogin || window.data_config.emailCodeLogin) && <div className="hasReg">
                    {WXPasswordShow && <div className="WXPassword">
                        <div className="title">
                            {React.language('wechat.registration')}
                        </div>
                        <LoginAccountInput value={this.account ? this.account.getValue().value : ""} mode={(window.data_config.mobileCodeLogin && window.data_config.emailCodeLogin) ? "" : window.data_config.mobileCodeLogin ? "mobile" : window.data_config.emailCodeLogin ? "email" : ""} getValue={this.accountValue}/>
                        <ImgCodeInput getValue={this.imgCodeValue}/>
                        {window.sitesetting.protocol_switch !== "0" && <div onClick={this.radioClick} className={"legalWebsite " + (check ? "select" : "")}>
                            <i className={check ? "icon-bsy-check3" : "icon-bsy-gou"}/>
                            <p><a className="website" target="_blank" href={window.rootDirectroy +"/agreement/termsOfService"}>{React.language("Website.Terms")}</a>/<a target="_blank" className="legal" href={window.rootDirectroy +"/agreement/legalDeclarationClause"}>{React.language("Legal.Privacy")}</a></p>
                        </div>}
                        <BsyBtn onClick={this.codeLogin} text={React.language('m.code.send')}/>
                    </div>}
                    {EntryInputCodeShow && <EntryInputCode LoginCode={this.LoginCode} />}
                    {BindWXShow && <div className="bindWXPage">
                        <div className="title">
                            {React.language('prompt1')}
                        </div>
                        <div className="bindTip">
                            <p className="tipTop">
                                <i className="icon-bsy-tip">

                                </i>
                                <span dangerouslySetInnerHTML={{__html:React.language('wxbind.tip',{
                                        value:mobileValue
                                    })}}>

                            </span>
                            </p>
                            <p className="tipButton">
                                {React.language('wxbind.tip1')}
                            </p>
                        </div>
                        <BsyBtn onClick={this.WXBindClick} text={React.language('wxbind.login')}/>
                    </div>}
                    {SetNameShow && <LoginCodeSetName changeContCodePage={this.changeContCodePage} />}
                    {LoginCodeSetPasswordShow && <LoginCodeSetPassword />}
                </div>}
                {(!window.data_config.mobileCodeLogin && !window.data_config.emailCodeLogin) && <div className="emptyReg">
                    {React.language('reg.login.empty.tip')}
                </div>}
            </div>
        );
    }
}

export default LoginWXReg;